import React from "react";

import { TenantCardTemplate } from "./tenant-card.template";

export type TenantStatusName = "Internal" | "NonOperating" | "Operating" | "Decommissioned";

export interface TenantStatus {
	name: TenantStatusName;
	id: number;
}

export interface TenantMeta {
	id: string;
	type: string;
	company: string;
	siteId: string;
	salesForceId: string;
	siteTimeZone: string;
	expiresAt: string | null;
	tenantStatus: TenantStatus;
}
export interface TenantCardProps {
	readonly tenant: TenantMeta;
	readonly onClick: (tenant: TenantMeta) => void;

	readonly tenantStatus: TenantStatusName;
	readonly currentUserId?: string;
	readonly tenantcardActions?: React.ReactNode;
}

export const TenantCard: React.FC<TenantCardProps> = ({
	tenant,
	onClick,
	tenantStatus,
	currentUserId,
	tenantcardActions,
}) => {
	const isActiveTenant = currentUserId === tenant.id;

	const loginTenant = (e: React.MouseEvent) => {
		e.stopPropagation();
		onClick(tenant);
	};

	return (
		<TenantCardTemplate
			tenant={tenant}
			isActiveTenant={isActiveTenant}
			tenantStatus={tenantStatus}
			onClick={loginTenant}
			tenantcardActions={tenantcardActions}
		/>
	);
};
